
export default {
  install(Vue){
    Vue.prototype.getOpenid=function(page) {
        var host='http://xcqyzs.asmaia.com/yuanhe';
        if (localStorage.getItem("openid") != 'undefined' && localStorage.getItem("openid") != null)
          return;
        var code = this.getUrlParam("code");
        if (code == 'undefined' || code == null || code == "") {
          //alert("参数异常，请返回首页重试");
          this.urlredirect(page);
          return;
        }
        this.$http.post(host + "/interface/getAccessTokenEp", {
            code: code
          }, {
            emulateJSON: true
          })
          .then(res => {
            //发送成功
            if (res.body.code == '0') {
              console.log(res);
              localStorage.setItem("openid", res.body.data);
              this.$store.commit("getId",res.body.data)
            } else {
              //console.log(res);
              this.urlredirect(page);
            }

            //if()
          }, res => {
            //发送失败
          })

      }

      Vue.prototype.urlredirect=function(page) {
        var host='http://xcqyzs.asmaia.com/yuanhe';
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4c68ff17fd9b2f14&redirect_uri=" + host + "/mobile/" + page + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      }
      Vue.prototype.getUrlParam=function(name) {
        var vars = [],
          hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
        }
        return decodeURIComponent(vars[name]);
      }
  }


}



// WEBPACK FOOTER //
// ./src/script/common.js